import commonConfig from './common';

const appConfig = {
  ...commonConfig,
};

export default appConfig;
